import { apiClient } from './axios';
import { ActivityDashboardResponse } from '../types/activityDashboard';

export const activityDashboardApi = {
    getActivity: (startDate: string, endDate: string) =>
        apiClient.get<ActivityDashboardResponse>(
            `/admin/dashboard/activity?startDate=${startDate}&endDate=${endDate}`,
        ),
};
